import React from 'react';

const AlertBar = ({alertMsg}) => (
<div className="cb-notification" id='notificationModal' style={{backgroundColor:'#fedb00'}} role="region" aria-labelledby="categoryNotice">
<div className="cb-notification-container" style={{alignItems:'left', padding:'5px'}}>
  <div className="cb-notification-header" style={{width:'100%', justifyContent: 'center'}}>
    <span className="cb-icon cb-icon-circular cb-megaphone cb-blue3-color" aria-hidden="true"></span>
    <span><h4 className="cb-notification-title" id="categoryNotice" dangerouslySetInnerHTML={{__html:alertMsg}}></h4></span>
  </div>
</div>
</div>
);

export default AlertBar;